import { IErrorStyleModule } from 'tag/ts/tag/interfaces/config/error/IErrorStyleModule';

/**
 * @description Error styles
 */
export const ErrorStyle: IErrorStyleModule = {
	url: {
		color: '#0099FF !important'
	}
};